var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgFacebook = function SvgFacebook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 13 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    height: "100%",
    width: "100%"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.423 27V14.732h3.845l.57-4.79H8.422V6.904c0-1.4.366-2.34 2.217-2.34H13V.3A27.22 27.22 0 0 0 9.541.015a5.012 5.012 0 0 0-2.308.37A5.342 5.342 0 0 0 5.29 1.779a5.847 5.847 0 0 0-1.206 2.148 6.16 6.16 0 0 0-.24 2.496v3.52H0v4.79h3.845V27h4.578Z",
    fill: "#DDD"
  })));
};

export default SvgFacebook;